const moment = require('moment')

export default {
  namespaced: true,
  state: {
    items: [],
    roles: [{
        value: "ROLE_ADMIN",
        text: "Administrateur"
      },
      {
        value: "ROLE_SHOP_USER",
        text: "Demandeur Client"
      },
      {
        value: "ROLE_DIRECTION",
        text: "Direction"
      },
      {
        value: "ROLE_PREPARATOR",
        text: "Préparateur"
      },
      {
        value: "ROLE_VERSATILE_TECHNICIAN",
        text: "Technicien polyvalent"
      },
      {
        value: "ROLE_MAINTAINER",
        text: "Technicien de maintenance"
      },
      {
        value: "ROLE_DISPATCHER",
        text: "Dispatcheur"
      }
    ]
  },
  getters: {
    // Par défaut on n'affiche jamais les superadmin
    getAll: state => state.items.filter(item => item.roles && !item.roles.includes('ROLE_SUPER_ADMIN')),
    getByRole: state => role => state.items.filter(item => item.roles == role),
    getByStatusSlug: state => status => state.items.filter(item => item.status_slug == status || item.status.status_slug == status),
    getByAgencyId: state => agency => state.items.filter(item => !item.roles.includes('ROLE_SUPER_ADMIN') && (!item.roles.includes('ROLE_SHOP_USER') || (item.agencies && item.agencies.find(ag => ag.id == agency)))),
    getByAgencyNumberAndStatusSlug: state => ({agency, status}) => state.items.filter(item => (item.agencies && item.agencies.map(ag => ag.internal_number).includes(agency)) && (item.status_slug == status || item.status.status_slug == status)),
    getItem: state => id => state.items.find(item => item.id == id),
    getRoles: state => state.roles,
    getRole: state => role => state.roles.find(item => item.value == role)
  },
  actions: {

    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAll: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'user',
        api_data_path: 'users',
        namespace: 'user'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllByRoles: (context, {wait = false, roles}) => {
      let params = {
        wait: wait,
        api_url: 'user',
        api_data_path: 'users',
        namespace: 'user',
        query: roles.map(role => 'role_id[]=' + role).join('&')
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelect: (context, wait = false) => {
      let params = {
        wait: wait,
        api_url: 'user/index/select',
        api_data_path: 'users',
        namespace: 'user'
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    /**
     * Charge tous les items via l'API dans le state avec des données limitées. Si des données sont déjà présentes dans le state, le résolve() est lancé de suite
     * @param   {boolean} wait  Si wait = true, on attends vraiment que les données soient reçues pour lancer le resolve() (impératif pour charger un formulaire de modification)
     * @returns {promise}       Aucune donnée n'est retournée
     */
    getAllForSelectByRoles: (context, {wait = false, roles}) => {
      let params = {
        wait: wait,
        api_url: 'user/index/simple',
        api_data_path: 'users',
        namespace: 'user',
        query: roles.map(role => 'role_id[]=' + role).join('&')
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getAllForSelectBySearch: (context, {wait = false, search, add = false}) => {
      let params = {
        wait: wait,
        api_url: 'user/index/simple',
        api_data_path: 'users',
        namespace: 'user',
        query: 'search=' + search,
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getAllForSelectByAuthorization: (context, {wait = false, authorization, add = false}) => {
      let params = {
        wait: wait,
        api_url: 'user/index/simple',
        api_data_path: 'users',
        namespace: 'user',
        query: 'authorization=' + authorization,
        add: add
      }
      return context.dispatch('getAll', params, {
        root: true
      })
    },
    getItem: (context, {
      id,
      wait = false, add = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'user',
        namespace: 'user',
        id: id,
        add: add
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    getItemByEmployeeNumber: (context, {
      employee_number,
      wait = false, add = false
    }) => {
      let params = {
        wait: wait,
        api_url: 'user/employee_number',
        namespace: 'user',
        id: employee_number,
        add: add
      }
      return context.dispatch('getItem', params, {
        root: true
      })
    },
    addItem(context, item) {
      let params = {
        api_url: 'user',
        namespace: 'user',
        item: item
      }
      return context.dispatch('addItem', params, {
        root: true
      })
    },
    saveItem(context, item) {
      let params = {
        api_url: 'user',
        namespace: 'user',
        item: item
      }
      return context.dispatch('saveItem', params, {
        root: true
      })
    },
    deleteItem(context, id) {
      let params = {
        api_url: 'user',
        namespace: 'user',
        id: id
      }
      return context.dispatch('deleteItem', params, {
        root: true
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/modules/user.js